import TicketStatusBadge from './TicketStatusBadge';
import { TICKET_CATEGORIES } from '../../lib/validators/ticketSchema';

const CATEGORY_LABEL = Object.fromEntries(TICKET_CATEGORIES.map((c) => [c.value, c.label]));

function formatDate(iso) {
  if (!iso) return '—';
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? '—' : d.toLocaleDateString();
}

/**
 * Card-based ticket row — replaces the dense table on both the investor
 * "My tickets" list and the admin queue. Headline fields only (subject,
 * category, status, last activity, plus investor name on the admin side);
 * everything else lives behind the click-through to the full thread.
 */
export default function TicketCard({ ticket, onClick, showInvestor }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="glass-card glass-card-hover w-full text-left p-4 sm:p-5 flex flex-col gap-2.5"
    >
      <div className="flex items-start justify-between gap-2">
        <h3 className="text-sm font-semibold text-foreground leading-snug truncate">{ticket.subject}</h3>
        <TicketStatusBadge status={ticket.status} />
      </div>

      {showInvestor && <p className="text-xs text-foreground-subtle truncate">{ticket.investor?.fullName || '—'}</p>}

      <div className="flex items-center justify-between gap-2 text-xs text-foreground-subtle pt-2 border-t border-border">
        <span>{CATEGORY_LABEL[ticket.category] || ticket.category || '—'}</span>
        <span>{formatDate(ticket.updatedAt || ticket.createdAt)}</span>
      </div>
    </button>
  );
}
